import { useEffect } from 'react';

import { useComponentFetcher } from '~/components/ComponentErrorBoundary/useComponentFetcher';

import type { SubscriptionBillingSummary } from '~/interfaces/subscriptions';

interface Props {
  enabled: boolean;
}

interface ReturnProps {
  isLoading: boolean;
  billingSummary?: SubscriptionBillingSummary | Record<string, never>;
  enabled?: boolean;
}

const useBillingSummary = ({ enabled }: Props): ReturnProps => {
  const fetcher = useComponentFetcher<() => Promise<SubscriptionBillingSummary | Record<string, never>>>();

  useEffect(() => {
    if (enabled) {
      fetcher.load('/billing_summary');
    }
  }, [enabled]);

  const isLoading = fetcher.state === 'loading' || !fetcher?.data;

  return {
    isLoading: isLoading && enabled,
    billingSummary: fetcher?.data || undefined,
  };
};

export default useBillingSummary;
